import { render, staticRenderFns } from "./SomministraCustomTeleconsultoSurvey.vue?vue&type=template&id=ec0f28e8"
import script from "./SomministraCustomTeleconsultoSurvey.vue?vue&type=script&lang=js"
export * from "./SomministraCustomTeleconsultoSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports